import { debounce } from "lodash";
import { useCallback, useMemo, useState } from "react";

import { useEmployeeExpectations } from "~/entity/Employee/hooks/useEmployeeExpectations";
import { EmployeeExpectationPosition } from "~/entity/Employee/model/schema";

export const useGetPositionsRestForSelect = () => {
  const { expectations, loading } = useEmployeeExpectations();
  const [search, setSearch] = useState("");

  const options = useMemo(() => {
    const byInstanceId: Record<string, EmployeeExpectationPosition> = {};
    expectations.forEach((expectation) => {
      (expectation.positions || []).forEach((position) => {
        const key = String(position.instanceId);
        if (position.status === "active" && !byInstanceId[key]) {
          byInstanceId[key] = position;
        }
      });
    });

    const mapped = Object.keys(byInstanceId).map((key) => {
      const position = byInstanceId[key];
      return {
        value: key,
        label: `${position.code}. ${position.name}`,
      };
    });

    mapped.sort((a, b) =>
      a.label.localeCompare(b.label, undefined, { numeric: true }),
    );

    if (!search) {
      return mapped;
    }

    const needle = search.toLowerCase();

    return mapped.filter((option) =>
      option.label.toLowerCase().includes(needle),
    );
  }, [expectations, search]);

  const onSearch = useMemo(
    () =>
      debounce((value: string) => {
        setSearch(value);
      }, 300),
    [],
  );

  const onOpenChange = useCallback((open: boolean) => {
    if (open) {
      setSearch("");
    }
  }, []);

  return { options, loading, onSearch, onOpenChange };
};
